import {Component, HostListener, OnInit} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import { DoraProperty, DoraPropertyArray } from 'src/app/Decorators/Decorator';
import { Column } from './data/column';
import { DataType } from 'src/app/pusblisher/ipublisher';
import { DataRow } from 'src/app/DoraData/data-row';
import {DataTupla} from '../../DoraData/data-tupla';
import {timer, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DataTuplaDescription} from '../../DoraData/data-tupla-description';
import {PublisherParameter} from '../widget-base/data/publisher-parameter';
import {TUPLA_TYPE} from '../../DoraData/data-base';
import {ReadResult} from '../../pusblisher/data/read-result';

@Component({
  selector: 'dora-row',
  templateUrl: './dora-row.component.html',
  styleUrls: ['./dora-row.component.scss']
})
export class DoraRowComponent extends WidgetBaseComponent implements OnInit {
  @DoraProperty
  private idrow = '';

  @DoraProperty
  // tslint:disable-next-line:variable-name
  protected fl_show_name = false;

  @DoraProperty
  // tslint:disable-next-line:variable-name
  private animation_steps = 20;

  @DoraProperty
  // tslint:disable-next-line:variable-name
  private animation_time = 100;

  @DoraPropertyArray (Column)
    // tslint:disable-next-line:variable-name
  columns_a: Column[] = [];

  @DoraPropertyArray (Column)
    // tslint:disable-next-line:variable-name
  columns_b: Column[] = [];

  @DoraPropertyArray (Column)
    // tslint:disable-next-line:variable-name
  columns_c: Column[] = [];

  @DoraProperty
  protected toolTipEnabled = false;

  dataRow: DataRow = null;

  flAllIncremented = false;
  flTimerStarted = false;

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    // set translation on columns
    this.setTraslationOnClumns(this.columns_a);
    this.setTraslationOnClumns(this.columns_b);
    this.setTraslationOnClumns(this.columns_c);

    this.readData();
  }

  private readData(): void {
    if (this.idrow === '') {
      // idrow not set
      return;
    }
    // Read row

    // get additional parameters
    const publisherParameters  = this.getPublisherParameters(this.publisherParameters);

    this.read([this.idrow], DataType.ROW, publisherParameters).subscribe((data: any) => {
      console.log('received');
      this.dataRow = (data as ReadResult).Data as DataRow;
      this.onNewData();
    });

    }

  private onNewData(): void {
    if (this.dataRow === null) {
      return;
    }
    this.flAllIncremented = false;
    this.flTimerStarted = false;

    this.initValues(this.columns_a);
    this.initValues(this.columns_b);
    this.initValues(this.columns_c);
    this.checkScroll();
  }

  private setTraslationOnClumns(columns: Column[]): void {
    columns.forEach((column: Column) => {
      column.translationService = this.translationService;
    });
  }
  private initValues(columns: Column[] ): void {
    columns.forEach((column: Column) => {

      // get tupla from received data
      const dataTupla: DataTupla = this.dataRow.getDataTupla(column.Name);
      if (dataTupla === undefined) {
        console.log('Column [' + column.Name + '] not found in data');
        return;
      }

      column.currentValue = dataTupla.clone();
      column.numberOfSteps = this.animation_steps;
    });
  }


  @HostListener('window:scroll', ['$event'])
  checkScroll() {


    if (this.flTimerStarted === true) {
      return;
    }
    const elemTop = this.elementRef.nativeElement.getBoundingClientRect().top;
    const elemBottom = this.elementRef.nativeElement.getBoundingClientRect().bottom;

    console.log('Component pos [' + this.elementRef.nativeElement.offsetTop + ']');
    console.log('Component clientRect [' + elemTop + '] [' + elemBottom + ']');
    console.log('window.pageYOffset [' + window.pageYOffset + ']');
    console.log('window.innerHeight [' + window.innerHeight + ']');

    if (elemTop >= 0 && elemBottom <= window.innerHeight) {
      this.checkTimer();
    }

  }

  private checkTimer(): void {
    this.flTimerStarted = true;
    const myTime = timer(this.animation_time);
    myTime.subscribe(value => {
      this.incrementAllValues();
      if (this.flAllIncremented === false) {
        this.checkTimer();
      }
    });
  }

  /**
   * Increment all values.
   * If all values reached the end set flAllIncremented
   */
  private incrementAllValues(): void {
    if (this.flAllIncremented === true) {
      return;
    }
    this.flAllIncremented = true;
    if (this.incrementValues(this.columns_a) === false) {
      this.flAllIncremented = false;
    }
    if (this.incrementValues(this.columns_b) === false) {
      this.flAllIncremented = false;
    }
    if (this.incrementValues(this.columns_c) === false) {
      this.flAllIncremented = false;
    }
  }

  /**
   * Increment all number values for a specific set of columns.
   * If all number ok set flAllIncremented
   */
  private incrementValues(columns: Column[]): boolean {
      let result = true;
      columns.forEach((column: Column) => {
       if (column.incrementValue() === false) {
         result = false;
       }
    });
      return result;
  }
  public getColumnCssClass(column: Column, index: number): string {
    let cssClass = 'column-container column-container-' + index + ' ' + column.Name;
    // tslint:disable-next-line:no-trailing-whitespace

    if (column.currentValue.Type === TUPLA_TYPE.NUMBER || column.currentValue.Type === TUPLA_TYPE.PERCENTAGE) {
      if (column.finalValueNumber > 0 ) {
        cssClass += ' positive';
      } else if (column.finalValueNumber < 0) {
        cssClass += ' negative';
      } else {
        cssClass += ' equal';
      }

    }
    return cssClass;
  }
  public getColumnUnitDx(column: Column, index: number): string {
    return column.valueStr === '' ? '' : column.UnitDx;
  }

  public getColumnUnitSx(column: Column, index: number): string {
    return column.valueStr === '' ? '' : column.UnitSx;
  }

  public getToolTip(column: Column): string {
    if (this.toolTipEnabled === true) {
      return this.translationService.getWithDefault(column.Name + '_TOOLTIP', '');
    }
    return '';
  }

  /**
   * Return true if the tooltip is enabled
   */
  public isToolTipEnabled(column: Column): boolean {
    if (this.toolTipEnabled === true) {
      if (this.getToolTip(column) !== '') {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
  public getToolTipVisibility(column: Column): string {
    return column.tooltipVisible === true ? 'visible' : 'hidden';
  }

  public onHeaderTooltipMouseEnter(column: Column): void {
    column.tooltipVisible = true;
  }
  public onHeaderTooltipMouseLeave(column: Column): void {
    column.tooltipVisible = false;
  }
}
